import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_accents_bookends: FaireCategoryEntity = {
  token: "cat_accents-bookends",
  type: "category",
  name: "Bookends",
  level: 3,
  parentToken: "cat_home-decor-accents",
  href: "/category/home-decor/home-accents/bookends",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
